export default "__VITE_ASSET__BdRdG8tG__"